module.exports = __webpack_public_path__ + "img/logo_mynaviwomen.f23b0c3b.png";